function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatusCreated = function SvgStatusCreated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5591"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0h-13A1.538 1.538 0 0 0 0 1.5v11A1.538 1.538 0 0 0 1.5 14h13a1.538 1.538 0 0 0 1.5-1.5v-11A1.538 1.538 0 0 0 14.5 0zM14 12H2V2h4.1v4.7L8 5.3l1.9 1.5V2H14z",
    "data-name": "Path 11819",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(3 6.999)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5592"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5.5a1.075 1.075 0 0 1-1 1H.5a1.075 1.075 0 0 1-1-1 1.075 1.075 0 0 1 1-1h13a1.075 1.075 0 0 1 1 1z",
    "data-name": "Path 11820",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(4 3.999)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5593"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5.5a1.075 1.075 0 0 1-1 1h-9a1.075 1.075 0 0 1-1-1 1.075 1.075 0 0 1 1-1h9a1.075 1.075 0 0 1 1 1z",
    "data-name": "Path 11821",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(6 .999)"
  })));
};
export default SvgStatusCreated;